var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "custom-tree-node",
      class: { "show-more": _vm.moreBtnShow },
      on: { mouseenter: _vm.mouseEnterHandler },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "context-menu",
              rawName: "v-context-menu",
              value: { params: _vm.params, data: _vm.$menuButtons },
              expression: "{ params: params, data: $menuButtons }",
            },
          ],
          staticClass: "tree-name",
          attrs: { id: _vm.data._id + "_navtree_nodeid" },
          on: {
            click: function ($event) {
              $event.stopPropagation()
              return _vm.currNodeChange.apply(null, arguments)
            },
          },
        },
        [
          _c(
            "span",
            { staticClass: "tree-name-label" },
            [
              !_vm.$navTreeCtrl.icons
                ? [
                    _vm.data[_vm.$navTreeCtrl.defaultProps.children] !==
                      undefined && _vm.$navTreeCtrl.showIcon
                      ? _c("i", {
                          class: [
                            "iconfont",
                            _vm.node.expanded
                              ? "icon-dakai"
                              : "icon-wenjianjia",
                          ],
                        })
                      : _vm.$navTreeCtrl.showIcon
                      ? _c("i", { staticClass: "iconfont icon-shiyongwendang" })
                      : _vm._e(),
                    _vm._t(
                      "nodeLabel",
                      function () {
                        return [
                          _c("span", {
                            domProps: {
                              innerHTML: _vm._s(
                                _vm.dsf.safe.xss(
                                  _vm.data[_vm.$navTreeCtrl.defaultProps.label]
                                )
                              ),
                            },
                          }),
                        ]
                      },
                      { data: _vm.data }
                    ),
                  ]
                : _vm._l(
                    _vm.$navTreeCtrl.icons.filter(function (icon) {
                      return _vm.getIconClass(icon, _vm.node)[0] != ""
                    }),
                    function (icon, iconI) {
                      return _c("i", {
                        key: iconI,
                        staticClass: "iconfont",
                        class: _vm.getIconClass(icon, _vm.node),
                        style: { color: icon.color },
                      })
                    }
                  ),
              _vm._t(
                "nodeLabel",
                function () {
                  return [
                    _c("span", {
                      attrs: {
                        title: _vm.dsf.safe.xss(
                          _vm.data[_vm.$navTreeCtrl.defaultProps.label]
                        ),
                      },
                      domProps: {
                        innerHTML: _vm._s(
                          _vm.dsf.safe.xss(
                            _vm.data[_vm.$navTreeCtrl.defaultProps.label]
                          )
                        ),
                      },
                    }),
                  ]
                },
                { data: _vm.data }
              ),
            ],
            2
          ),
          _vm.isMouseEnter && _vm.buttons.length > 0
            ? _c(
                "span",
                {
                  on: {
                    click: function ($event) {
                      $event.stopPropagation()
                    },
                  },
                },
                [
                  _c("DsfButtonBar", {
                    ref: "btnCtrl",
                    staticClass: "ds-no-padding edit-span",
                    attrs: {
                      "render-button": _vm.$navTreeCtrl.renderRowButton,
                      "max-number": _vm.$navTreeCtrl.buttonsMaxNumber,
                      "more-button-style": "icon-text",
                      "more-button-text": "",
                      buttons: _vm.buttons,
                      "emit-prefix": "row-button",
                      local: _vm.data,
                      moreBtnColNum: _vm.$navTreeCtrl.moreBtnColNum,
                      size: "small",
                      align: "left",
                    },
                    on: { popoverState: _vm.popoverStateFn },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }